import { render, staticRenderFns } from "./PurchaseListForm.vue?vue&type=template&id=6d1e8910&lang=pug"
import script from "./PurchaseListForm.vue?vue&type=script&lang=js"
export * from "./PurchaseListForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports